import classNames from "classnames";
import React from "react";
import { RiCloseCircleLine } from "react-icons/ri";

const MarkerInfoModal = ({ isOpen, onClose, children, location }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg w-[480px]">
        <div className="flex flex-row items-center justify-between">
          <h2 className="text-xl font-bold">{location.name}</h2>
          <RiCloseCircleLine
            onClick={onClose}
            size={24}
            className="mb-2 cursor-pointer text-primaryblue"
          />
        </div>
        <p className="m-0 text-sm text-gray-600">{location.address}</p>
        {location.type !== "PROVIDER_HOME" && (
          <div
            className={classNames(
              "flex flex-col overflow-hidden mt-2 transition-all duration-300 bg-slate-50 pb-2 border rounded-md p-1 no-scrollbar",
              isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
            )}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default MarkerInfoModal;
